import React from 'react';
import { Collapse } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styles from './AddAccountCardModal.module.scss';

const AccountCardFormSection = ({ title, open, onToggle, summary, hasError = false, children }) => (
  <section className={`${styles.section} ${hasError ? styles.sectionError : ''}`}>
    <button
      type="button"
      className={styles.sectionHeader}
      onClick={onToggle}
      aria-expanded={open}
    >
      <span className={styles.sectionTitle}>{title}</span>
      <span className={styles.sectionSummary}>{!open && summary ? summary : ''}</span>
      <ExpandMoreIcon
        className={`${styles.sectionChevron} ${open ? styles.sectionChevronOpen : ''}`}
      />
    </button>
    <Collapse in={open} timeout="auto">
      <div className={styles.sectionBody}>{children}</div>
    </Collapse>
  </section>
);

export default AccountCardFormSection;
